module.exports = __webpack_public_path__ + "assets/img/baoche2.a0c0e136.png";